export default {"src":"/_next/static/media/search.f16ecdcb.svg","height":48,"width":46,"blurWidth":0,"blurHeight":0};